export default __webpack_public_path__ + "static/media/tick-blue.441b8a60.svg";